import { Component, OnInit, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { LotteryInstallmentConfigurationModel } from "src/app/model/LotteryInstallmentConfigurationModel";
import { SchemeInstallmentConfigurationModel } from "src/app/model/SchemeInstallmentConfigurationModel";

import { ModalController } from "@ionic/angular";

import { FormControl, FormGroup, Validators } from "@angular/forms";
import { MatTableDataSource } from "@angular/material/table";
import { TenementListResponse } from "src/app/model/TenementListResponse";
import { TenementInsConfigInitModel } from "src/app/model/TenementInsConfigInitModel";
import { RevertActivatedWaitlistConfigService } from "src/app/services/revert-activated-waitlist-config.service";
import { Page } from "src/app/model/Page";
import { ReverseWaitListResponce } from "src/app/model/ReverseWaitListResponce";
import { MatSort } from "@angular/material/sort";
import { MatPaginator, PageEvent } from "@angular/material/paginator";
import { ViewWtlstDtlsModalComponent } from "../view-wtlst-dtls-model/view-wtlst-dtls-model.component";
import { OprtdAppDtlsResponseModel } from "src/app/model/OprtdAppDtlsResponseModel";

@Component({
  selector: "app-secure-revert-activated-waitlist",
  templateUrl: "./revert-activated-waitlist.component.html",
  styleUrls: ["./revert-activated-waitlist.component.scss"],
})
export class RevertActivatedWaitlistComponent implements OnInit {
  
  isLoading = false;
  isProgressBarLoading: Boolean = false;
  oprtdAppDtls: OprtdAppDtlsResponseModel;
  pageSizeOptions: number[] = [10, 25, 100];
  pageSize = 10;
  currentPage = 0;
  lotteries: { [key: number]: string };
  lotteriesWthtPun: { [key: number]: string };
  dataSource: MatTableDataSource<ReverseWaitListResponce> = new MatTableDataSource();
  onInItLstData: Page<ReverseWaitListResponce>;
  isSearchDisabled: boolean = false;
  schemes: { [key: number]: string };
  building: string[];
  twing: string[];
  floor: number[];
  flatNo: number[];
  selectedLottery: any;
  selectedScheme: any;
  selectedBldg: string = "";
  selectedWing: string = "";
  selectedFloor: string = "";
  selectedFlatNo: number;
  selectedTenementKeys: number[];
  tenementKeys: number[]=[];
  installmentTypes: { [key: number]: string };
  lotteryInstallmentConfigs: LotteryInstallmentConfigurationModel[] = [];
  schemeInstallmentConfigs: SchemeInstallmentConfigurationModel[] = [];
  isSubmitDisabled: boolean = false;
  lotteryKey: { key: number; value: string };
  schemeKey: { key: number; value: string };
  isAddAllowedForLottery: boolean;
  isAddAllowedForScheme: boolean;
  otherInstallmentNames: string[];
  filterFormGroup: FormGroup = new FormGroup({});
  tenementDetails: TenementListResponse[];
  // dataSource: MatTableDataSource<TenementListResponse>;
  selectedTenements: TenementListResponse[] =[];
  selectedTenement: TenementListResponse;
  isHeaderCheckboxChecked: boolean = false;
  count: string;
  allTenementConfig: TenementInsConfigInitModel[];
  
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  displayedColumns: string[] = [
    "oprtAppNo",
    // "oprtdWnrOprtdDt",
    "oprtdLtrSchCode",
    "tnmntDtls",
    "tnmntSts",
    "actdAppNo",
    "actdLtrSchCode",
    "action",
  ];

  constructor(
    private router: Router,
    private modalCtrl: ModalController,
    private revertActivatedWaitlistConfigService: RevertActivatedWaitlistConfigService
  ) {}

  ngOnInit(): void {
    this.filterFormGroup = new FormGroup({
      lotteryFilter: new FormControl(null),
      schemeFilter: new FormControl(null),
      filterText: new FormControl(null),
    });

    this.loadData();
  }

  loadData() {
    this.isLoading = true;
    this.isProgressBarLoading = true;
    this.revertActivatedWaitlistConfigService.initLotteryEventForRevertActdWlt(this.currentPage, this.pageSize, 
      this.filterFormGroup.value.filterText, this?.selectedLottery, this?.selectedScheme).subscribe((data)=>{
        this.isLoading = true;
        if(data.status === "SUCCESS"){
          console.log(" REVERT WAITLIST data >> ",data);
          this.lotteries = data.lotteryList;

          const keyToRemove: number = 21;

          if (keyToRemove in this.lotteries) {
              const value = this.lotteries[keyToRemove];
              delete this.lotteries[keyToRemove];
          }
          this.lotteriesWthtPun = this.lotteries;

          this.onInItLstData = data.reverseWaitListResponce;
          console.log("data.reverseWaitListResponce.content >> ", data.reverseWaitListResponce.content);
          this.dataSource = new MatTableDataSource(
            data.reverseWaitListResponce.content
          );

          setTimeout(() => {
            this.paginator.pageIndex = this.currentPage;
            this.paginator.length = this.onInItLstData.totalElements;
            console.log(this.paginator.pageIndex);
            console.log(this.paginator.length);
          });
          this.isProgressBarLoading = false;
        }

        this.isLoading = false;
    }, 
    (error)=>{
      console.log("error >> ",error);
    });

    this.isLoading = false;
  }

  private getDtlsOfOprtdApp(element: ReverseWaitListResponce): Promise<any> {
    return new Promise((resolve, reject) => {
        this.revertActivatedWaitlistConfigService.getDtlsOfOprtdApp(element).subscribe(
            (data) => {
              console.log("resolve data >> ",data);
              resolve(data);
            },
            (error) => {
              console.log("reject error >> ",error);
              reject(error);
            }
        );
    });
  }

  // async viewDtlsOfOprtdAndActd(element: ReverseWaitListResponce){
  //   this.isProgressBarLoading = true;
  //   console.log("modal element >> ",element);
    
  //   this.oprtdAppDtls = await this.getDtlsOfOprtdApp(element);
    
  //   console.log("this.oprtdAppDtls >> ", this.oprtdAppDtls);

  //   const modal = await this.modalCtrl.create({
  //     component: ViewWtlstDtlsModalComponent,
  //     cssClass: "master-modal-lg",
  //     componentProps: {
  //       header: "WAITLIST DETAILS",
  //       reverseWaitListResponce: element,
  //       fileType: "Waitlist Revert Order File",
  //       oprtdAppDtls: this.oprtdAppDtls,
  //     },
  //   });
    
  //   this.isProgressBarLoading = false;
  //   modal.present();

  //   const { data, role } = await modal.onWillDismiss();

  //   if(role === "Submit"){
  //     this.isProgressBarLoading = true;
  //     console.log("Modal Return Data >> ", data);
  //     console.log("oprtd key >> ",element.oprtAppKey);
  //     console.log("actd key >> ",element.actdAppKey);
  //     this.revertActivatedWaitlistConfigService.revertWaitlist(data[0], data[1], data[2], data[3], data[4] ?? null, data[5] ?? null,
  //       element?.oprtAppKey, element?.actdAppKey).subscribe((data) => {
  //         console.log("revert response >> ",data);

  //         if (!data) {
  //           this.handleNullDataError();
  //           return;
  //         }

  //         if(data.status === "SUCCESS"){
  //           this.revertActivatedWaitlistConfigService.successToast("Waitlist Reverted Successfully");
  //           this.loadData();
  //         }else{
  //           this.revertActivatedWaitlistConfigService.errorToast(
  //             data.errorMessage
  //           );
  //           this.isProgressBarLoading = false;
  //         }
  //     },
  //     (error) =>{
  //       this.revertActivatedWaitlistConfigService.errorToast(
  //         error?.error?.message || error?.error?.errorMessage
  //       );
  //       this.isProgressBarLoading = false;
  //     });
  //   }
    
  // }

  async viewDtlsOfOprtdAndActd(element: ReverseWaitListResponce) {
    this.isProgressBarLoading = true;
    console.log("modal element >> ", element);
  
    try {
      this.oprtdAppDtls = await this.getDtlsOfOprtdApp(element);
      console.log("this.oprtdAppDtls >> ", this.oprtdAppDtls);
  
      const modal = await this.modalCtrl.create({
        component: ViewWtlstDtlsModalComponent,
        cssClass: "master-modal-lg",
        componentProps: {
          header: "WAITLIST DETAILS",
          reverseWaitListResponce: element,
          fileType: "Waitlist Revert Order File",
          oprtdAppDtls: this.oprtdAppDtls,
        },
      });
  
      this.isProgressBarLoading = false;
      await modal.present();
  
      const { data, role } = await modal.onWillDismiss();
  
      if (role === "Submit") {
        this.isProgressBarLoading = true;
        console.log("Modal Return Data >> ", data);
        console.log("oprtd key >> ", element.oprtAppKey);
        console.log("actd key >> ", element.actdAppKey);
  
        try {
          const revertResponse: any = await this.revertActivatedWaitlistConfigService
            .revertWaitlist(
              data[0], 
              data[1], 
              data[2], 
              data[3], 
              data[4] ?? null, 
              data[5] ?? null,
              element?.oprtAppKey, 
              element?.actdAppKey
            ).toPromise();
  
          console.log("revert response >> ", revertResponse);
  
          if (!revertResponse) {
            this.handleNullDataError();
          } else if (revertResponse.status === "SUCCESS") {
            this.revertActivatedWaitlistConfigService.successToast("Waitlist Reverted Successfully");
            this.ngOnInit();
          } else {
            this.revertActivatedWaitlistConfigService.errorToast(revertResponse.errorMessage);
          }
        } catch (error) {
          console.error("Error in revertWaitlist", error);
          this.revertActivatedWaitlistConfigService.errorToast(error?.error?.message || error?.error?.errorMessage);
        } finally {
          this.isProgressBarLoading = false;
        }
      }
    } catch (error) {
      console.error("Error in viewDtlsOfOprtdAndActd", error);
      this.revertActivatedWaitlistConfigService.errorToast("Failed to load details.");
      this.isProgressBarLoading = false;
    }
  }  

  handleNullDataError() {
    this.revertActivatedWaitlistConfigService.errorToast("Received null or undefined data");
    this.isProgressBarLoading = false;
  }

  onLotteryChange(e: any) {
    this.schemes = {};
    this.selectedLottery = e.key;

    if (e?.key > 0) {
      this.isLoading = true;
      this.revertActivatedWaitlistConfigService.initScheme(e.key).subscribe(
        (data) => {
          this.isLoading = false;
          if (data.status === "SUCCESS") {
            this.schemes = data.schemes;
          } else {
            this.revertActivatedWaitlistConfigService.errorToast(data.errorMessage);
            this.isLoading = false;
          }
        },
        (error) => {
          this.revertActivatedWaitlistConfigService.errorToast(
            error?.error?.message || error?.error?.errorMessage
          );
          this.isLoading = false;
        }
      );
    }
  }

  onSchemeChange(e: any) {
    this.selectedScheme = e.key;
  }

  pageChanged(event: PageEvent) {
    console.log({ event });
    this.pageSize = event.pageSize;
    this.currentPage = event.pageIndex;
    this.loadData();
  }

  toggleHeaderCheckbox(checked: boolean) {
    // this.isHeaderCheckboxChecked = checked;
    // console.log(
    //   "this.isHeaderCheckboxChecked before check>>",
    //   this.isHeaderCheckboxChecked
    // );
    // if (checked) {
    //   if (
    //     this.dataSource.filteredData.filter(
    //       (element) => element.tenementConfigExists === "Y"
    //     ).length > 0
    //   ) {
    //     console.log("Tenement have config.");
    //     console.log("this.selectedElement", this.selectedTenements);
    //     this.dataSource.data.forEach((element: TenementListResponse) => {
    //       if (element.tenementConfigExists === "N") {
    //         this.selectedTenements.push(element);
    //       }
    //     });
    //     console.log(
    //       "this.selectedElement after filter data>>",
    //       this.selectedTenements
    //     );
    //     this.count = this.selectedTenements.length.toString();

    //     if (this.selectedTenements.length === 0) {
    //       setTimeout(() => {
    //         this.isHeaderCheckboxChecked = false;
    //       });
    //       return this.tenementInsConfigService.errorToast(
    //         "No eligible data is avaiable"
    //       );
    //     }
    //   } else {
    //     this.selectedTenements = this.dataSource.filteredData.slice();
    //     console.log("Fill Select all", this.selectedTenements);
    //   }
    // } else {
    //   this.selectedTenements = [];
    //   console.log("Empty Select all", this.selectedTenements);
    // }
    // this.count = this.selectedTenements.length.toString();
  }

  onSearch() {
    this.isProgressBarLoading = true;

    if (!this.selectedLottery) {
      this.isProgressBarLoading = false;
      this.isSearchDisabled = false;
      return this.revertActivatedWaitlistConfigService.errorToast(
        "Please Select Lottery from the filter."
      );
    }

    if (!this.selectedScheme) {
      this.isProgressBarLoading = false;
      this.isSearchDisabled = false;
      return this.revertActivatedWaitlistConfigService.errorToast(
        "Please Select Scheme from the filter."
      );
    }

    // if(this.filterFormGroup.value.filterText == null){
    //   return this.revertActivatedWaitlistConfigService.errorToast(
    //     "Please Enter Application Number"
    //   );
    // }

    if (this.filterFormGroup.valid) {
      this.revertActivatedWaitlistConfigService
        .getAppDtls(
          this.currentPage,
          this.pageSize,
          this?.selectedLottery,
          this?.selectedScheme,
          this.filterFormGroup.value.filterText,
        )
        .subscribe(
          (data) => {
            if (data.status === "SUCCESS") {
              this.isProgressBarLoading = false;
              this.isSearchDisabled = false;

              this.onInItLstData = data.reverseWaitListResponce;
              console.log("data.reverseWaitListResponce.content >> ", data.reverseWaitListResponce.content);
              this.dataSource = new MatTableDataSource(
                data.reverseWaitListResponce.content
              );

              setTimeout(() => {
                this.paginator.pageIndex = this.currentPage;
                this.paginator.length = this.onInItLstData.totalElements;
                console.log(this.paginator.pageIndex);
                console.log(this.paginator.length);
              });
              this.isProgressBarLoading = false;

              this.isLoading = false;
            } else {
              this.revertActivatedWaitlistConfigService.errorToast(data.errorMessage);
            }
          },
          (error) => {
            this.revertActivatedWaitlistConfigService.errorToast(
              error?.error?.message || error?.error?.errorMessage
            );
            this.isProgressBarLoading = false;
          }
        );
    }
  }

  resetFilter(){
    this.filterFormGroup = new FormGroup({
      lotteryFilter: new FormControl(null),
      schemeFilter: new FormControl(null),
      filterText: new FormControl(null),
    });
    this.selectedLottery =null;
    this.selectedScheme =null;
    this.loadData();
  }

}
